import { Injectable } from '@angular/core';
import * as Sentry from "@sentry/angular";

import { ApiService } from 'anatoliapps-angular/services';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LoggerService extends ApiService {

  //#region Constructor
  constructor() { super(environment.apiUrl); }
  //#endregion

  public log(error: Error){
    Sentry.captureException(error);
  }
  
}
